export enum PageUniqueKeys {
    insuranceTertiaryCardExistingClientPageV1 = 'insuranceTertiaryCardExistingClientPageV1',
    insuranceTertiaryCardNewClientPageV1 = 'insuranceTertiaryCardNewClientPageV1',
  }
  
  export enum ModalQuestionnairePageIds {
    patientAgeGroupInsuranceZipCodePage = 'patientAgeGroupInsuranceZipCodePage',
  }
  
  export enum QuestionnaireGroupType {
    INDIVIDUAL_CLIENT_CHECKOUT = 'INDIVIDUAL_CLIENT_CHECKOUT',
    INDIVIDUAL_CLIENT_CHECKIN = 'INDIVIDUAL_CLIENT_CHECKIN',
    SELF_MATCHING_CLIENT_INTAKE = 'SELF_MATCHING_CLIENT_INTAKE',
  }
  
  export enum QuestionsUniqueKeys {
    childdateOfBirthSelfMatchingClientQuestionV1 = 'childdateOfBirthSelfMatchingClientQuestionV1',
    yearbeginpracticeTherapistQuestionV1 = 'yearbeginpracticeTherapistQuestionV1',
    yeargraduatedTherapistQuestionV1 = 'yeargraduatedTherapistQuestionV1',
    patientdateofbirthSelfMatchingClientChoiceV1 = 'patientdateofbirthSelfMatchingClientChoiceV1',
    patientsAgeSelfMatchingClientQuestionV1 = 'patientsAgeSelfMatchingClientQuestionV1',
    patientLocation = 'patientLocation',
  }